import {createTheme, ThemeProvider} from "@mui/material";
import {QueryClientProvider} from "@tanstack/react-query";
import {RouterProvider} from "@tanstack/react-router";
import NewReleasePrompt from "@/components/NewReleasePrompt.tsx";
import {appRouter} from "@/Routes.tsx";
import {queryClient} from "@/utils/queryClient.ts";
import NoticeProvider from "./components/Providers/NoticeProvider.tsx";
import {ScheduledMaintenance} from "./pages/ScheduledMaintenance.tsx";

const theme = createTheme({
    palette: {
        primary: {
            main: "#631d79",
            50: "#FAF5FF",
        },
        secondary: {
            main: "#9333EA",
        },
        background: {
            default: "#f5f5f5",
            paper: "#ffffff",
        },
    },
});

const App = () => {
    return (
        <ThemeProvider theme={theme}>
            <QueryClientProvider client={queryClient}>
                <ScheduledMaintenance>
                    <NoticeProvider>
                        <RouterProvider router={appRouter} />
                        <NewReleasePrompt />
                    </NoticeProvider>
                </ScheduledMaintenance>
            </QueryClientProvider>
        </ThemeProvider>
    );
};

import("./utils/injectMockFilemaker.ts");

export default App;
